import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const promoApi = axios.create({ baseURL: API });

promoApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("ss_promo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

promoApi.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    const authRelated =
      status === 401 &&
      (detail === "Invalid token" ||
        detail === "Token expired" ||
        detail === "Not authenticated" ||
        detail === "Wrong token type" ||
        detail === "Account not found");
    if (authRelated && typeof window !== "undefined") {
      try { localStorage.removeItem("ss_promo_token"); } catch (_) { /* ignore */ }
      if (window.location.pathname.startsWith("/promo") && window.location.pathname !== "/promo/login") {
        window.location.replace("/promo/login");
      }
    }
    return Promise.reject(error);
  }
);

export default promoApi;
